import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      image: "https://randomuser.me/api/portraits/women/32.jpg",
      name: "Sarah Johnson",
      position: "Marketing Director",
      text: '"VibeXMedia transformed our digital presence. Their campaign increased our leads by 150% in just three months!"'
    },
    {
      image: "https://randomuser.me/api/portraits/men/54.jpg",
      name: "Michael Chen",
      position: "CEO, TechStart",
      text: '"The team\'s creativity and data-driven approach delivered exceptional ROI on our advertising spend."'
    },
    {
      image: "https://randomuser.me/api/portraits/women/67.jpg",
      name: "Jennifer Lopez",
      position: "Brand Manager",
      text: '"Their video production team captured our brand essence perfectly. The commercials have gone viral!"'
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h2 className="section-title">Client Testimonials</h2>
            <p>What our clients say about our services</p>
          </div>
        </div>
        <div className="row">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-md-4">
              <div className="testimonial-card">
                <div className="d-flex align-items-center mb-4">
                  <img src={testimonial.image} className="client-img" alt="Client" />
                  <div>
                    <h5 className="mb-0">{testimonial.name}</h5>
                    <p className="mb-0">{testimonial.position}</p>
                  </div>
                </div>
                <p>{testimonial.text}</p>
                <div className="rating">
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;